import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AdminImage from '../Images/admin-login.webp';
import './ALogin.css';

const ALogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    // Perform login validation
    if (username === 'admin' && password === 'admin123') {
      // Clear error message
      setError('');
      // Redirect to admin dashboard
      localStorage.setItem("wAdminLocal", "LoggedIn")
      window.location.href = '/admin';
    }
     else {
      // Display error message for invalid credentials
      setError('Invalid username or password');
    }
  };

  return (
    <div className="alogin container">
      <div className="admin-left">
        <center>
          <img className="admin-login-image" src={AdminImage} alt="Admin Login" />
        </center>
      </div>
      <div className="admin-right">
        <form onSubmit={handleLogin}>
          <h3>Admin Login</h3>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              className="form-control"
              name="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              className="form-control"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p className="text-danger">{error}</p>}
          <button type="submit" className="btn btn-primary mt-2">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default ALogin;
